import { render } from "./WishListView.vue?vue&type=template&id=cc8ccd3a&scoped=true"
import script from "./WishListView.vue?vue&type=script&lang=js"
export * from "./WishListView.vue?vue&type=script&lang=js"

import "./WishListView.vue?vue&type=style&index=0&id=cc8ccd3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc8ccd3a"]])

export default __exports__